<template>
  <div id="footer" v-if="isShown">
    <span v-if="isTNEMode && phase">{{ `phase: ${phase} |` }}</span>
    <span
      >version:
      <tip
        :tip="`ui version: ${UI_VERSION} | api version: ${version}`"
        class="footer-tip"
        tip-location="top-right"
      >
        <span>{{ systemVersion }}</span>
      </tip>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Tip from './tip/Tip.vue'

export default {
  data() {
    return {
      UI_VERSION: '',
      isShown: true,
      routeForHide: /^\/(report|pdf)\//g
    }
  },
  async created() {
    this.UI_VERSION = ___UI_VERSION___.replace(/-.*-/, '.')
  },
  watch: {
    /**
     * Hide footer based on the route change
     * @param  {string} newVal the path of current route
     */
    routePath(newVal) {
      let me = this
      if (newVal.match(me.routeForHide)) {
        me.isShown = false
      } else {
        me.isShown = true
      }
    }
  },
  computed: {
    isTNEMode() {
      const platform = this.$store.state.platform
      if (platform && 'API mode' in platform) {
        const mode = this.$store.state.platform['API mode']
        return mode === 'T&E'
      } else {
        return false
      }
    },
    systemVersion() {
      const platform = this.$store.state.platform
      if (platform && 'Swarm version' in platform) {
        const version = platform['Swarm version']
        return `v${version}`
      } else {
        return 'unknown'
      }
    },
    ...mapGetters(['user', 'version', 'phase', 'routePath'])
  },
  components: {
    Tip
  }
}
</script>

<style lang="scss" scoped>
#footer {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  height: 25px;
  color: #a0a0a0;
  text-align: right;
  font-size: 12px;
  font-family: 'Source Sans Pro', serif;
  padding: 2px 18px 0px 0;
  background-color: #fafafb;
  border-top: 1px solid rgba(220, 220, 220, 0.8);
  box-shadow: 20px 0px 40px 0 rgba(0, 0, 0, 0.12);
  z-index: 100;
  span {
    cursor: default;
  }
}
</style>
